<template>
  <div class="backgroud-white">
     <div class="popup-content-area-small">
    <el-row>
      <el-col :span="8">
        课程: {{data.courseName}}
      </el-col>
      <el-col :span="12">
        课程周: {{data.courseWeekString}}
      </el-col>
    </el-row>
    <pagination v-loading="loading" :data="listData" :option="paginationOption"></pagination>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.popup-content-area-small{
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>

<script>
import pagination from "./common/pagination";
import {
  getWatchHistory
} from "../service/videoAppointment.service";
export default {
  props: {
    data:{
      courseName: String,
      courseWeekString: String,
      courseActivationId: Number
    }
  },
  data() {
    return {
      loading: false,
      listData: {},
      paginationOption: {},
      searchKeyword: "",
      pageSize: 20
    };
  },
  components: {
    pagination
  },
  created() {
    this.paginationOption = {
      displayPagination: false,
      hasEditButton: false,
      editButtonText: "编辑",
      hasAddButton: false,
      addButtonText: "添加",
      hasDeleteButton: false,
      hasSearch: false,
      hasEnableButton: false
    };

    this.getListData();
  },
  methods: {
    getListData() {
      if (!this.data){
        return;
      }
      
      this.loading = true;
      getWatchHistory(this.data.courseActivationId).then(result => {
        if (result && result.success) {
          this.listData = result.data;
        }
        this.loading = false;
      });
    }
  },
  watch: {
    data: function() {
      this.getListData();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/watchHistoryList.vue